<template>
	<div>
		<slot name="start">
            You Have
        </slot>
		<h1>
			<ion-badge :color="color" class="big-badge credits-badge">
				{{ value }}
			</ion-badge>
		</h1>
		<slot name="end">
            <p><small>available credits</small></p>
        </slot>
	</div>
</template>

<script lang="ts" setup>

const { value, color } = defineProps({
                   value: Number,
                   color: {type: String, default: "danger" } 
                });

</script>
